import Datepicker from 'components/common/Datepicker';
import palette from 'lib/styles/palette';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import useContractCreator from 'hooks/contract/useContractCreator';
import PlaceBox from 'components/contract/contractCreator/PlaceBox';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import { useSelector } from 'react-redux';

const ContractCreator = ({ edit }) => {
  const navigate = useNavigate();

  const { store, updateStore } = useSelector(
    ({ contract }) => contract.contractRegisterForm,
  );

  const {
    company,
    code,
    name,
    tel,
    detail,
    userId,
    password,
    passwordConfirm,
    username,
    team,
    position,
    userTel,
    email,
    errors,
    isLoading,
    error,
    updateContractMutation,
    onChange,
    onSubmit,
    onEdit,
  } = useContractCreator(edit);

  if (isLoading || updateContractMutation?.isLoading) return <Loading />;
  if (
    error?.response.status === 500 ||
    updateContractMutation.error?.response.status === 500
  )
    return <ErrorNoti errorMsg="서버 오류가 발생했습니다" />;

  return (
    <ContractCreatorBlock>
      <div className="title">{edit ? '계약 수정' : '신규 계약 등록'}</div>
      <div className="wrapper">
        <div className="index">회사명</div>
        <StyledInput
          type="text"
          name="company"
          value={company}
          onChange={e => onChange(e, 'contract')}
        />
        {errors.company && (
          <div className="contract-creator-error-msg">{errors.company}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">SI코드</div>
        <StyledInput
          type="text"
          name="code"
          value={code}
          onChange={e => onChange(e, 'contract')}
        />
        {errors.code && (
          <div className="contract-creator-error-msg">{errors.code}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">계약 기간</div>
        <div className="date-wrapper">
          <Datepicker edit={edit} />
        </div>
      </div>
      <div className="wrapper">
        <div className="index">계약자</div>
        <StyledInput
          type="text"
          name="name"
          value={name}
          onChange={e => onChange(e, 'contract')}
        />
        {errors.name && (
          <div className="contract-creator-error-msg">{errors.name}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">계약자 연락처</div>
        <StyledInput
          type="text"
          name="tel"
          value={tel}
          onChange={e => onChange(e, 'contract')}
        />
        {errors.tel && (
          <div className="contract-creator-error-msg">{errors.tel}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">계약 내용</div>
        <StyledTextarea
          rows="3"
          type="text"
          placeholder="선택입력"
          name="detail"
          value={detail}
          onChange={e => onChange(e, 'contract')}
        />
      </div>
      <div className="wrapper">
        <div className="index">설치 장소 입력</div>
        <PlaceBox edit={edit} />
      </div>
      <div className="divider" />
      <div className="wrapper">
        <div className="index">Master ID</div>
        <StyledInput
          type="text"
          name="userId"
          value={userId}
          onChange={e => onChange(e, 'user')}
        />
        {errors.userId && (
          <div className="contract-creator-error-msg">{errors.userId}</div>
        )}
      </div>
      {!edit && (
        <>
          <div className="wrapper">
            <div className="index">비밀번호</div>
            <StyledInput
              type="password"
              name="password"
              value={password}
              onChange={e => onChange(e, 'user')}
            />
            {errors.password && (
              <div className="contract-creator-error-msg">
                {errors.password}
              </div>
            )}
          </div>
          <div className="wrapper">
            <div className="index">비밀번호 재확인</div>
            <StyledInput
              type="password"
              name="passwordConfirm"
              value={passwordConfirm}
              onChange={e => onChange(e, 'user')}
            />
            {errors.passwordConfirm && (
              <div className="contract-creator-error-msg">
                {errors.passwordConfirm}
              </div>
            )}
          </div>
        </>
      )}
      <div className="wrapper">
        <div className="index">사용자 이름</div>
        <StyledInput
          type="text"
          name="name"
          value={username}
          onChange={e => onChange(e, 'user')}
        />
        {errors.username && (
          <div className="contract-creator-error-msg">{errors.username}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">부서</div>
        <StyledInput
          type="text"
          name="team"
          value={team}
          onChange={e => onChange(e, 'user')}
        />
        {errors.team && (
          <div className="contract-creator-error-msg">{errors.team}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">직급</div>
        <StyledInput
          type="text"
          name="position"
          value={position}
          onChange={e => onChange(e, 'user')}
        />
        {errors.position && (
          <div className="contract-creator-error-msg">{errors.position}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">연락처</div>
        <StyledInput
          type="text"
          name="tel"
          value={userTel}
          onChange={e => onChange(e, 'user')}
        />
        {errors.userTel && (
          <div className="contract-creator-error-msg">{errors.userTel}</div>
        )}
      </div>
      <div className="wrapper">
        <div className="index">이메일</div>
        <StyledInput
          type="text"
          name="email"
          value={email}
          onChange={e => onChange(e, 'user')}
        />
        {errors.email && (
          <div className="contract-creator-error-msg">{errors.email}</div>
        )}
      </div>
      <div className="btn-wrapper">
        <StyledButton
          cancel="true"
          onClick={() => navigate('/admin/contracts')}
        >
          취소
        </StyledButton>
        <StyledButton
          onClick={edit ? onEdit : onSubmit}
          disabled={store.length === 0 && updateStore.length === 0 && !edit}
        >
          {edit ? '완료' : '등록'}
        </StyledButton>
      </div>
    </ContractCreatorBlock>
  );
};

export default ContractCreator;

const ContractCreatorBlock = styled.div`
  width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;

  .title {
    font-size: 1.3rem;
    font-weight: bold;
    margin-top: 30px;
  }

  .wrapper {
    margin-top: 25px;
    width: 100%;
    display: flex;
    flex-direction: column;
    .date-wrapper {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .index {
    font-weight: 600;
  }

  .divider {
    margin-top: 25px;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .btn-wrapper {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    width: 220px;
  }

  .contract-creator-error-msg {
    margin-top: 0.2rem;
    font-size: 12px;
    color: red;
  }
`;

const StyledInput = styled.input`
  margin-top: 6px;
  border: solid 1px #dfdfdf;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const StyledTextarea = styled.textarea`
  border: solid 1px #dfdfdf;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  margin-top: 6px;
  resize: none;
`;

const StyledButton = styled.button`
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 40px;
  background: ${props => (props.cancel ? palette.theme[0] : palette.theme[3])};
  cursor: pointer;
  &:hover {
    background: ${props =>
      props.cancel ? palette.theme[2] : palette.theme[2]};
  }
  &:disabled {
    background: ${palette.theme[0]};
  }
`;
